import React from "react";
import { Spinner } from "@chakra-ui/react";
import { FiSend } from "react-icons/fi";
import { Button } from "newui/components/Button";
import { useClarificationsRegisterContext } from "./ClarificationsRegisterContext";

export const ClarificationsRegisterToolbar: React.FC = () => {
  const { data, selection, modals, props } = useClarificationsRegisterContext();
  const { selectableItems } = data;
  const { selectedIds, handleSelectAll } = selection;
  const { isSending, handleSendSelected } = modals;
  const { isClientView, rfxId, rfxSubmissionId } = props;

  if (!(rfxSubmissionId || rfxId) || selectableItems.length === 0) {
    return null;
  }

  return (
    <div className="border-b border-gray-200 bg-blue-50 px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={selectedIds.length === selectableItems.length}
              onChange={handleSelectAll}
              className="h-4 w-4 rounded border-gray-300 text-blue-600"
            />
            <span className="text-sm font-medium text-blue-700">
              {selectedIds.length} of {selectableItems.length} draft {isClientView ? 'clarifications' : 'responses'} selected
            </span>
          </label>
        </div>
        <Button
          onClick={handleSendSelected}
          disabled={selectedIds.length === 0 || isSending}
          className="flex items-center gap-2"
          data-testid="send-clarifications-button"
        >
          {isSending ? (
            <Spinner size="sm" />
          ) : (
            <>
              <FiSend className="h-4 w-4" />
              Send Selected
            </>
          )}
        </Button>
      </div>
    </div>
  );
};
